import React, {Component} from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router, Route, Switch, Redirect } from 'react-router-dom';

import Login from './components/Login/Login';
import Sidebar from './components/Headers/Sidebar';
import TopMenu from './components/Headers/TopMenu';
import ManageSwayam from './components/ManageSwayam/ManageSwayam';
import ManageSwayamORG from './components/ManageSwayam/ManageSwayamORG';
import ManagePayments from './components/ManagePayments/ManagePayments';
import NotFound from './components/NotFound/NotFound';
// import ManageSwayamORGTable from './components/ManageSwayam/ManageSwayamORGTable';

require('dotenv').config()

const readCookie = require('./cookie.js').readCookie;
const eraseCookie = require('./cookie.js').eraseCookie;

const userData = JSON.parse(readCookie('userData'));
const access_token = JSON.parse(readCookie('access_token'));

const DefaultLayout = ({component: Component, ...rest}) => {
  console.log("rest", rest);
  return (
    <Route {...rest} render={matchProps => (
      <div className="le-back-office-container">
        <Sidebar activated_tabs={[]} selected={rest.selected} openKey={rest.openKey} />
        <TopMenu userData={userData} logoutUser={rest.logoutUser} />
        <Component {...matchProps} paymentGateway={rest.paymentGateway} readCookie={readCookie} access_token={access_token} />
      </div>
    )} />
  )
};

export default class Routes extends Component {
  constructor(props) {
    super(props);
    this.state = {
      userData: null
    };
  }

  logoutUser() {
    fetch(process.env.REACT_APP_API_URL + '/logout', {
      method: 'GET',
      headers: {
        'Auth': JSON.parse(readCookie('access_token'))
      }
    }).then(function(response) {
      return response.json();
    }).then(function(data) {
      eraseCookie('userData');
      eraseCookie('access_token');
      eraseCookie('leBackOfficeVersion');
      this.setState({ userData: null });
      window.location.pathname = '';
    }.bind(this)).catch(function(error) {
      console.log('There has been a problem with your fetch operation: ' + error.message);
    });
  }

  componentWillMount() {
    if(readCookie('userData') !== null) {
      if(readCookie('leBackOfficeVersion') !== null) {
        if(readCookie('leBackOfficeVersion') === process.env.REACT_APP_VERSION) {
          let userData = JSON.parse(readCookie('userData'));
          this.setState({ userData });
        } else {
          eraseCookie('userData');
          eraseCookie('access_token');
          eraseCookie('leBackOfficeVersion');
          window.location.pathname = '';
        }
      } else {
        eraseCookie('userData');
        eraseCookie('access_token');
        eraseCookie('leBackOfficeVersion');
        window.location.pathname = '';
      }
    } else {
      eraseCookie('userData');
      eraseCookie('access_token');
      eraseCookie('leBackOfficeVersion');
    }
  }

  render() {
    return (
      <Router>
        <div>
          {(() => {
            if(this.state.userData !== null) {
              return (
                <div>
                  <Switch>
                    <Redirect exact from="/" to="/manage-swayam" />
                    <DefaultLayout exact path="/manage-swayam" component={ManageSwayam} selected={['manage-organisations', 'manage-swayam']} openKey='manage-swayam' logoutUser={this.logoutUser.bind(this)} />
                    <DefaultLayout exact path="/manage-swayam/org/:orgId" component={ManageSwayamORG} selected={['manage-organisations', 'manage-swayam']} openKey='manage-swayam' logoutUser={this.logoutUser.bind(this)} />
                    <DefaultLayout exact path="/manage-payments" component={ManagePayments} selected={['manage-payments', 'manage-swayam']} openKey='manage-swayam' logoutUser={this.logoutUser.bind(this)} />
                    <Route component={NotFound} />
                    {/* <ManageSwayamORGTable /> */}
                  </Switch>
                </div>
              )
            } else {
              return (
                <div>
                  <Switch>
                    <Route exact path="/" component={Login} />
                    <Redirect exact from="/*" to="/" />
                  </Switch>
                </div>
              );
            }
          })()}
        </div>
      </Router>
    );
  }
}

ReactDOM.render(
  <Routes />,
  document.getElementById('root')
);


// WEBPACK FOOTER //
// ./src/index.js